import { combineReducers } from 'redux';

let uIdValue = {
    uIdValue: false
};
const uIdValueReducer = (state = uIdValue, action) => {
    switch (action.type) {
        case "uIdValue": {
            return {
                uIdValue: action.payLoad
            };
        }
        default: {
            return state;
        }
    }
};

let azureToken = {
    token: "",
};
const saveAzureTokenReducer = (state = azureToken, action) => {
    switch (action.type) {
        case "saveAzureAccessToken": {
            return {
                token: action.payLoad,
            };
        }
        default: {
            return state;
        }
    }
};
let bearerToken = {
    token: "",
};
const saveBearerTokenReducer = (state = bearerToken, action) => {
    switch (action.type) {
        case "saveBearerToken": {
            return {
                bearerToken: action.payLoad,
            };
        }
        default: {
            return state;
        }
    }
};

const saveBearerTokenReducerPhyInv = (state = bearerToken, action) => {
    switch (action.type) {
        case "saveBearerToken": {
            return {
                bearerToken: action.payLoad,
            };
        }
        default: {
            return state;
        }
    }
};

let uid = {
    token: "",
};
const saveUIDReducer = (state = uid, action) => {
    switch (action.type) {
        case "saveUID": {
            return {
                uid: action.payLoad,
            };
        }
        default: {
            return state;
        }
    }
};

const saveUIDReducerPhyInv = (state = uid, action) => {
    switch (action.type) {
        case "saveUID": {
            return {
                uid: action.payLoad,
            };
        }
        default: {
            return state;
        }
    }
};

let userDataInitialState = {
    userData: {
        gid: "",
        roleId: 0,
        roleName: "",
        userEmail: "",
        userFirstName: "",
        userLastName: "",
        userId: 0,
    },
};

const storeUserDetailsReducer = (state = userDataInitialState, { type, payLoad }) => {
    switch (type) {
        case 'storeUserData': {
            return {
                userData: {
                    ...payLoad,
                },
            };
        }
        default: {
            return state;
        }
    }
}

const storeUserDetailsReducerPhyInv = (state = userDataInitialState, { type, payLoad }) => {
    switch (type) {
        case 'storeUserData': {
            return {
                userData: {
                    ...payLoad,
                },
            };
        }
        default: {
            return state;
        }
    }
}

const storeMenuItems = [];
    const storeLandingMenuItemsReducer = (state = storeMenuItems, action) => {
    switch (action.type) {
    case "saveLandingMenuItems": {
      return {
        menuItems: action.payLoad,
      };
    }
    
    default: {
      return state;
    }
  }
};

    const storeEperformanceMenuItems = [];
    const storeEperformanceLandingMenuItemsReducer = (state = storeEperformanceMenuItems, action) => {
    switch (action.type) {
    case "saveEperformanceLandingMenuItems": {
      return {
        menuItems: action.payLoad,
      };
    }
    
    default: {
      return state;
    }
  }
    };

    const storePhyInvMenuItems = [];
    const storePhyInvLandingMenuItemsReducer = (state = storePhyInvMenuItems, action) => {
    switch (action.type) {
    case "savePhyInvLandingMenuItems": {
      return {
        menuItems: action.payLoad,
      };
    }
    
    default: {
      return state;
    }
  }
    };




let AppIDInitialState = {
    AppID: "",
}

const AppIDReducer = (state = AppIDInitialState, action) => {
    switch (action.type) {
        case 'AppID': {
            return {
                AppID: action.payLoad,
            };
        }
        default: {
            return state;
        }
    }
}


export const masterReducer = combineReducers({
    uIdValueReducer: uIdValueReducer,
    saveAzureTokenReducer: saveAzureTokenReducer,
    saveBearerTokenReducer: saveBearerTokenReducer,
    saveBearerTokenReducerPhyInv:saveBearerTokenReducerPhyInv,
    saveUIDReducer: saveUIDReducer,
    saveUIDReducerPhyInv:saveUIDReducerPhyInv,
    storeUserDetailsReducer: storeUserDetailsReducer,
    storeUserDetailsReducerPhyInv:storeUserDetailsReducerPhyInv,
    storeLandingMenuItemsReducer: storeLandingMenuItemsReducer,
    storeEperformanceLandingMenuItemsReducer:storeEperformanceLandingMenuItemsReducer,
    storePhyInvLandingMenuItemsReducer:storePhyInvLandingMenuItemsReducer,
    AppIDReducer:AppIDReducer
   

})